import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { OtpType } from '@/modules/otp/enums/OtpType';

export class OtpContact extends BaseEntityModel {
  id?: number;

  type?: OtpType;

  userId?: number;

  phoneNumber?: string;

  email?: string;

  isVerified?: boolean;

  constructor(model: Partial<OtpContact> = {}) {
    super(model);

    this.id = model.id;
    this.type = model.type;
    this.userId = model.userId;
    this.phoneNumber = model.phoneNumber;
    this.email = model.email;
    this.isVerified = model.isVerified;
  }

  get isPhoneNumber(): boolean {
    return this.type === OtpType.PHONE_NUMBER;
  }
}
